export function extractErrorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  const e = err as any;
  // Go backend errors return { devMessage: "...", arg: "..." } where `arg`
  // contains the human-readable error detail (e.g. "the entity was not found
  // in the data store"). We fall through to `arg` when `message` is absent.
  return (
    e?.data?.message ?? e?.response?.data?.arg ?? e?.message ?? 'Unknown error'
  );
}
